import { type ValidatorFunction } from 'ember-changeset-validations';

export function validateIsModuleOf(numbers: number[]): ValidatorFunction {
  return (_key: string, newValue: unknown): boolean =>
    numbers.some((number) => Number(newValue) % number === 0);
}
